import { useState } from 'react'
import Axios from 'axios'

export const useExcelGenerator = () => {
  const [loading, setLoading] = useState(false)

  const generateExcel = async (header, dataItems, title) => {
    setLoading(true)

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${title}-${new Date().toLocaleDateString().split('/').join('-')}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
    }

    setLoading(false)
  }

  return { generateExcel, loading }
}
